import { render, staticRenderFns } from "./vNavigation.vue?vue&type=template&id=10a2d6d4&scoped=true"
import script from "./vNavigation.vue?vue&type=script&lang=ts"
export * from "./vNavigation.vue?vue&type=script&lang=ts"
import style0 from "./vNavigation.vue?vue&type=style&index=0&id=10a2d6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2d6d4",
  null
  
)

export default component.exports